import { createContext } from 'react';
import type { Session, User, AuthError } from '@supabase/supabase-js';

export interface AuthCtx {
  session: Session | null;
  user: User | null;
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<{ error?: AuthError }>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthCtx | null>(null);
